import { matchPath } from 'react-router'

import { $currentPage } from '@/models/router.ts'

import { HELP_DESK_ARTICLES } from './constants'

export const getCurrentPageName = (currentPath: string) => {
  for (const group of HELP_DESK_ARTICLES) {
    if (group.patterns.some((pattern) => matchPath(pattern, currentPath))) {
      const articleId =
        Number(group.helpDeskLink?.match(/\/articles\/(\d+)/)?.[1]) || 0

      return { ...group, articleId }
    }
  }

  return null
}

export const $helpDeskUrl = $currentPage.map(
  (newTitle) => getCurrentPageName(newTitle) ?? null,
)
